import {
    LIST_RECUSES,
    LIST_RECUSES_SUCCESS,
    LIST_RECUSES_ERROR,
    ADD_RECUSES,
    SAVE_RECUSES,
    SAVE_RECUSES_SUCCESS,
    SAVE_RECUSES_ERROR,
    EDIT_RECUSES,
    UPDATE_RECUSES,
    UPDATE_RECUSES_SUCCESS,
    UPDATE_RECUSES_ERROR,
    DELETE_RECUSES,
    DELETE_RECUSES_SUCCESS,
    DELETE_RECUSES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    recuses: null,
    actualPage: null,
    isLast: null,
    isFirst: null,
    total: null,
    totalPages: null,
    error: null,
    loading: false,
    recuseSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_RECUSES:
            return {
                ...state,
                loading: true
            }
        case LIST_RECUSES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_RECUSES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                recuses: action.payload.content,
                actualPage: action.payload.number,
                isLast: action.payload.last,
                isFirst: action.payload.first,
                total: action.payload.totalElements,
                totalPages: action.payload.totalPages
            }
        case SAVE_RECUSES:
        case DELETE_RECUSES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_RECUSES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_RECUSES_ERROR:
        case UPDATE_RECUSES_ERROR:
        case DELETE_RECUSES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_RECUSES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                recuses: [action.payload, ...state.recuses]
            }
        case ADD_RECUSES:
            return {
                ...state,
                recuseSelected: null,
                isEdit: false
            }
        case EDIT_RECUSES:
            return {
                ...state,
                recuseSelected: action.payload,
                isEdit: true
            }
        case UPDATE_RECUSES_SUCCESS:
        case DELETE_RECUSES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                recuses: state.recuses.map(recuse => 
                    recuse.id === action.payload.id ? recuse = action.payload : recuse
                ),
                recuseselected: null
            }
        // case DELETE_RECUSES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         recuses: state.recuses.filter( recuse => recuse.id !== action.payload)
        //     }
        default:
            return state;
    }
}